import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  body {
    font-size: 12px;
    font-family: 'Montserrat';
    overflow-x: hidden;

    @media (min-width: 600px) {
      font-size: 16px;
    }
  }

  .cut {
    text-decoration: line-through;
  }

  button {
    &:focus {
      outline: none;
    }
  }

  ul,
  ol {
    list-style: none;
  }

  img {
    display: block;
    max-width: 100%;
  }

  strong {
    font-weight: 700;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  .bold {
    font-weight: 600;
  }

  .pac-target-input {
    outline: none;
  }

  .pac-container.pac-logo {
    z-index: 2000;
  }
`;

export default GlobalStyle;
